// generated from 21 samples

import { z } from "zod";
import { common } from "../common";

export const performedCampaignExceptionTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::PerformedCampaignException"),
  // null: 2 (9.52%)
  selected_campaign_id: common.objectId.nullable(),
  // null: 2 (9.52%)
  selected_campaign_name: z.string().nullable(),
});
